// used by cph-epi\src\Cph.Website\Views\Blocks\ContactFormBlock\Index.cshtml

function contact() {
  removeElement("contact-name-notice")
  removeElement("contact-email-notice")
  let name = document.querySelector("#contact-name").value
  let email = document.querySelector("#contact-email").value
  let contentId = document.querySelector("#contentId").textContent
  let subject = document.querySelector("#select").value
  let message = document.querySelector("#contact-message").value
  if (validateContactForm(name, email)) {
    fetch("/api/FormApi/ContactForm?name=" + name + "&email=" + email + "&contentId=" + contentId + "&subject=" + subject + "&message=" + message, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          document.querySelector("#contactSuccessModalTemplate").classList.add("is-active")
        } else {
          document.querySelector("#contactFailureModalTemplate").classList.add("is-active")
        }
      })
      .catch(() => {
        document.querySelector("#contactFailureModalTemplate").classList.add("is-active")
      })
  }
}

function validateEmail(email) {
  const emailValidationRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailValidationRegex.test(email)
}

function validateContactForm(name, email) {
  let validationOk = true
  if (!name) {
    appendErrorNotice("contact-name", "contact-name-notice")
    validationOk = false
  }
  if (!validateEmail(email)) {
    appendErrorNotice("contact-email", "contact-email-notice")
    validationOk = false
  }
  return validationOk
}

function appendErrorNotice(elementId, noticeId) {
  let parent = document.querySelector("#" + elementId).parentNode
  let span = document.createElement("span")
  span.id = noticeId
  span.className = "form__notice  form__notice--box"
  span.textContent = "Error text, input is invalid"
  parent.appendChild(span)
}

function removeElement(elementId) {
  let element = document.querySelector("#" + elementId)
  if (element) {
    element.parentNode.removeChild(element)
  }
}

window.contact = contact
